import { SIGN_OUT } from '../actions/authActions/ActionTypes';
import {
  CLEAR_IMPERSONATION,
  SET_IMPERSONATION,
} from '../actions/impersonationActions/ActionTypes';
import { Action } from '../models/Action';

export interface ImpersonationState {
  companyId: number | null;
  roleIds: number[];
}

const defaultStore: ImpersonationState = {
  companyId: null,
  roleIds: [],
};

export default function ImpersonationReducer(
  state: ImpersonationState = defaultStore,
  action: Action
) {
  switch (action.type) {
    case SET_IMPERSONATION:
      return {
        companyId: action.payload.companyId,
        roleIds: action.payload.roleIds,
      };
    case CLEAR_IMPERSONATION:
    case SIGN_OUT:
      return {
        ...defaultStore,
      };
    default:
      return state;
  }
}
